import React from "react";
import Moment from "moment";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";

import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import EditIcon from "@material-ui/icons/Edit";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import SwapHorizontalCircleIcon from "@material-ui/icons/SwapHorizontalCircle";

import CardActions from "@material-ui/core/CardActions";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
  noPadding: {
    padding: 0,
  },
  title: {
    fontSize: 14,
  },
  card: {
    marginBottom: 12,
  },
  totalHours: {
    marginBottom: 5,
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

const HoursList = (props) => {
  const classes = useStyles();
  const { date, hours, totalHours, handleItemMenuClick, screenSize } = props;

  const handleOpenMenu = (e, hour, action) => {
    handleItemMenuClick(e, hour, action);
  };

  return (
    <React.Fragment>
      <Card id="hours-list" className={classes.totalHours} variant="outlined">
        <CardContent style={{ padding: 10, paddingRight: 20 }}>
          <Grid container>
            <Grid item xs={6}>
              <Typography color="textSecondary">
                Date: <b>{Moment(date).format("MM-DD-YYYY")}</b>
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <Typography color="textSecondary">
                Total Hours: <b>{totalHours.toFixed(2)}</b>
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {hours.map((hour, i) => {
        let completed = Moment(hour.Completed).format("YYYY-MM-DD");
        let starttime = Moment(`${completed}T${hour.StartTime}`).format("LT");
        let endtime = Moment(`${completed} ${hour.EndTime}`).format("LT");

        //Create Initial from Name for Avatar
        let name = hour.Name;
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");
        let initials = [...name.matchAll(rgx)] || [];

        initials = (
          (initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")
        ).toUpperCase();

        return (
          <Card
            className={clsx(classes.card, classes.noPadding)}
            variant="outlined"
            key={i}
          >
            <CardHeader
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  {initials}
                </Avatar>
              }
              action={
                <div>
                  <IconButton
                    title="Edit"
                    onClick={(e) => {
                      handleOpenMenu(e, hour, "EDIT");
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    title="Send Ticket To ZOHO"
                    onClick={(e) => {
                      handleOpenMenu(e, hour, "SEND_TICKET");
                    }}
                  >
                    <ConfirmationNumberIcon />
                  </IconButton>
                  <IconButton
                    title="Admin"
                    onClick={(e) => {
                      let newHour = hour;
                      newHour.Category = "Admin";
                      newHour.DorI = "InDirect";
                      handleOpenMenu(e, newHour, "MAKE_ADMIN");
                    }}
                  >
                    <VerifiedUserIcon />
                  </IconButton>
                  {/* <IconButton
                    title="InDirect"
                    onClick={(e) => {
                      let newHour = hour;
                      newHour.DorI = "InDirect";

                      handleOpenMenu(e, newHour, "MAKE_INDIRECT");
                    }}
                  >
                    <SwapHorizontalCircleIcon />
                  </IconButton> */}
                  <IconButton
                    title="Delete"
                    onClick={(e) => {
                      handleOpenMenu(e, hour, "DELETE");
                    }}
                  >
                    <DeleteForeverIcon color="primary" />
                  </IconButton>

                  {/* <IconButton
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={(e) => {
                      handleOpenMenu(e, hour);
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton> */}
                </div>
              }
              title={`${hour.Name}`}
              subheader={`From: ${starttime} To: ${endtime} - Qty:${hour.Qty.toFixed(
                2
              )}`}
            />

            <CardContent>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                dangerouslySetInnerHTML={{ __html: hour.Description }}
              ></Typography>
            </CardContent>
            <CardActions>
              <Chip
                size="small"
                color="secondary"
                variant="outlined"
                label={hour.DorI}
              />
              <Chip
                size="small"
                color="secondary"
                variant="outlined"
                label={hour.Category}
              />

              {hour.isRND === 1 && (
                <Chip size="small" color="primary" label={"R&D"} />
              )}

              {(screenSize == "md" ||
                screenSize == "lg" ||
                screenSize == "xl") &&
                hour.Platform &&
                hour.Platform != "" && (
                  <Chip size="small" color="secondary" label={hour.Platform} />
                )}
            </CardActions>

            {(screenSize == "sm" || screenSize == "xs") &&
              hour.Platform &&
              hour.Platform != "" && (
                <CardActions>
                  <Chip size="small" color="secondary" label={hour.Platform} />
                </CardActions>
              )}
          </Card>
        );
      })}
    </React.Fragment>
  );
};

export default HoursList;
